import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import Layout from './components/Layout';
import About from './components/Aboutpage';
import Schedule from './components/Schedule';
import Thematic from './components/Thematic';
import Speaker from './components/Speaker';
import Press from './components/Press';
import OtherLayout from './components/OtherLayout';
import Page from './components/Page';
import PageDetail from './components/Pagedetail';
import Pagedetail from './components/Pagedetail';
import NotFound404 from './components/NotFound404';
import Main from './components/Main';
import ExternalLink from './components/ExternalLink';
import SpeakerPage from './components/SpeakerPage';
import SpeakerPagedetails from './components/SpeakerPagedetails';
import RegisterLink from './components/RegisterLink';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<App />} />
          <Route path='*' element={<App />} />
        </Route>

        <Route path='/' element={<OtherLayout />}>
          <Route path='/about' element={<About />} />
          <Route path='/thematic' element={<Thematic />} />
          <Route path='/schedule' element={<Schedule />} />
          <Route path='/speaker' element={<Speaker />} />
          <Route path='/press' element={<Press />} />
          <Route path="/page/:id" element={<Page />} />
          <Route path="/pagedetail/:id" element={<Pagedetail />} />
          <Route path="/icdri-in-person" element={<ExternalLink />} />
          <Route path="/register" element={<RegisterLink />} />
          <Route path="/speakerdetails/:id" element={<SpeakerPagedetails />} />
          {/* <Route path='*' element={<NotFound404 />} /> */}
          <Route path='*' element={<App />} />

        </Route>


      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
